export const ADULTS = 'adults';
export const KIDS = 'kids';
export const COMPANION_GROUPS = {
  ADULTS,
  KIDS,
};
export const MAX_FORM_ADULTS = 6;
export const MAX_FORM_KIDS = 6;
export const MIN_FORM_ADULTS = 1;
export const MIN_FORM_KIDS = 0;
export const MAX_COMPANIONS = 7;
